module.exports = __webpack_public_path__ + "static/img/play@80x80.591d439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play@80x80.png
// module id = 523
// module chunks = 1 7 8